/* global Mustache */
/* global generic */
/* global site */
(function () {
  Drupal.behaviors.skinRhythmProductsHeroV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.js-skinrhythm-products--v1', context);
      var fullProductHtml = '';

      generic.template.get({
        path:
          '/sites/esteelauder/modules/custom/esteelauder_product/templates/_partials/product_full_v1/product_full.mustache',
        forceReload: true,
        callback: function (html) {
          fullProductHtml = html;
        }
      });

      function fireAnalytic(eventAction, eventLabel) {
        if (site && site.track) {
          site.track.evtLink({
            event_name: 'elSkinRhythm',
            event_category: 'skin rhythm 3 products module',
            event_action: eventAction,
            event_label: eventLabel
          });
        }
      }

      function addEventsToHeroProducts() {
        var $selectedHeroProductTemplate = $('.js-selected-hero-product-template');
        var $totalHeroProductTemplate = $thismodule.find('.js-boutique-skin-rhythm__products-hero-product-container-3');
        var products;

        if ($totalHeroProductTemplate.length > 0) {
          products = [1, 2, 3];
        } else {
          products = [1, 2];
        }
        products.forEach(function (value) {
          var $productElement = $thismodule.find('.js-boutique-skin-rhythm__products-hero-product-container-' + value);

          if ($productElement && $productElement.length > 0) {
            $productElement.on('click', function (event) {
              event.preventDefault();
              event.stopImmediatePropagation();
              openPanelOnProductClick(value, event.target.dataset, 'panel-is-visible-from-right', 'from-product-panel');
            });
          }
        });

        function openPanelOnProductClick(productPosition, dataset, visibilityClassName, analyticLabel) {
          var analyticProductId = '', $quickShopPanelContentElement;
          var $quickShopPanelElement = $thismodule.find('.js-boutique-skin-rhythm__products-quick-shop-panel-main-container-' + productPosition);
          var $quickShopPanelCloseElement = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-main-container-close');

          processCarouselPanelCloseEvent($quickShopPanelElement, $quickShopPanelCloseElement);
          $quickShopPanelContentElement = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-content');

          var drupalSettings = Drupal && Drupal.settings ? Drupal.settings : {};
          var drupalGlobalVars = drupalSettings && drupalSettings.globals_variables ? drupalSettings.globals_variables : {};
          var prodQtyLimit = drupalGlobalVars && drupalGlobalVars.qty_locale_override ? drupalGlobalVars.qty_locale_override : [];

          // this panel wasn't already open so we don't have all the info needed and events hooked.
          if ($quickShopPanelContentElement.children().length === 0) {
            var productId, productHeroImagePosition, productHeroImageUrl, productHeroImageAlt,
              skinRhythmProductsInHero, matchingSkinRhythmProductIndex, fullProductData, heroProductContext, selectedHeroProductHtml,
              $panelProductContent, fullProductHtmlRendered, $cartButton;

            if (dataset === null) {
              var $productElement = $thismodule.find('.js-boutique-skin-rhythm__products-hero-product-container-' + productPosition);
              var $productImageElement = $productElement.find('.js-boutique-skin-rhythm__products-hero-product-image img');

              productId = $productImageElement[0].dataset.productId;
              productHeroImagePosition = $productImageElement[0].dataset.productHeroImagePosition;
              productHeroImageUrl = $productImageElement[0].dataset.productHeroImageUrl;
              productHeroImageAlt = $productImageElement[0].dataset.productHeroImagePosition;
            } else {
              productId = dataset.productId;
              productHeroImagePosition = dataset.productHeroImagePosition;
              productHeroImageUrl = dataset.productHeroImageUrl;
              productHeroImageAlt = dataset.productHeroImagePosition;
            }

            skinRhythmProductsInHero = page_data['custom-mpp']['products'];

            matchingSkinRhythmProductIndex = skinRhythmProductsInHero
              .map(function (p) {
                return p.PRODUCT_ID;
              })
              .indexOf(productId);
            fullProductData = skinRhythmProductsInHero[matchingSkinRhythmProductIndex];

            heroProductContext = {
              productHeroImagePosition: productHeroImagePosition,
              productHeroImageUrl: productHeroImageUrl,
              productHeroImageAlt: productHeroImageAlt
            };

            selectedHeroProductHtml = Mustache.render(
              $selectedHeroProductTemplate.html(),
              heroProductContext
            );

            $quickShopPanelContentElement.html(selectedHeroProductHtml);

            $panelProductContent = $quickShopPanelContentElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-product-content');

            addContextInformationToProduct(fullProductData);

            fullProductHtmlRendered = Mustache.render(fullProductHtml, {
              product: fullProductData,
              qty_locale_override: prodQtyLimit
            });

            $panelProductContent.html(fullProductHtmlRendered);
            addCarouselPanelEvents($quickShopPanelElement, productPosition);
            analyticProductId = productId;
            // Initialize Add To cart.
            $cartButton = $quickShopPanelElement.find('.js-add-to-cart');
            if ($cartButton) {
              site.createAddButton($cartButton);
            }
            if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined' && typeof site.product.view.full !== 'undefined') {
              site.product.view.full({ productData: fullProductData });
            }
            $panelProductContent.find('.product-full__detail-link').attr('href', fullProductData['url']);
            $panelProductContent.find('.product-full__images').removeClass('slick-initialized slick-slider slick-dotted');
          }

          switch (visibilityClassName) {
            case 'carousel-is-visible':
              toggleCarouselIsVisibleClass($quickShopPanelElement, true);
              break;
            case 'panel-is-visible-from-right':
              $quickShopPanelElement.addClass(visibilityClassName);
              break;
          }
          fireAnalytic('Product: ' + analyticProductId, analyticLabel + ' click');
        }

        function addContextInformationToProduct(fullProductData) {
          var arOptionIndex;

          fullProductData['product_details'] = site.translations.product.product_details;
          if (fullProductData.skus.length > 0) {
            // if one size or shaded then the first_sku will be used
            if (fullProductData.skus.length === 1) {
              fullProductData['multiple_sizes'] = false;
            } else {
              fullProductData['multiple_sizes'] = true;
            }
            fullProductData['first_sku'] = fullProductData.skus[0];
          }

          fullProductData['auto_replenishment'] = site.translations.product.auto_replenishment;
          fullProductData['learn_more'] = site.translations.product.learn_more;

          for (arOptionIndex = 1; arOptionIndex < 8; arOptionIndex++) {
            var arValue = 'replenishment_option_' + arOptionIndex + '_value';
            var arText = 'replenishment_option_' + arOptionIndex + '_text';

            fullProductData[arValue] = site.translations.product[arValue];
            fullProductData[arText] = site.translations.product[arText];
          }

          fullProductData['add_to_cart'] = site.translations.product.add_to_cart;
          fullProductData['add_to_wishlist'] = site.translations.product.add_to_wishlist;
        }

        function openPanelOnCarouselClick(
          $previousQuickShopPanelElement,
          productPosition,
          visibilityClassName
        ) {
          removePanelIsVisibleFromRightLeftClasses($previousQuickShopPanelElement);
          toggleCarouselIsVisibleClass($previousQuickShopPanelElement, false);
          openPanelOnProductClick(productPosition, null, visibilityClassName, 'from-carousel-panel');
        }

        function addCarouselPanelEvents($quickShopPanelElement, productPosition) {
          var $quickShopPanelSwitcherElementLeft = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-content-switch-left');
          var $quickShopPanelSwitcherElementRight = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-content-switch-right');

          $quickShopPanelSwitcherElementLeft.on('click', function (event) {
            processCarouselPanelEvent($quickShopPanelElement, productPosition, event);
            fireAnalytic('carousel left ' + productPosition, 'click');
          });

          $quickShopPanelSwitcherElementRight.on('click', function (event) {
            processCarouselPanelEvent($quickShopPanelElement, productPosition, event);
            fireAnalytic('carousel right ' + productPosition, 'click');
          });
        }

        function processCarouselPanelEvent($quickShopPanelElement, productPosition, event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var carouselIsVisibleClass = 'carousel-is-visible';

          productPosition = determineCorrectProductPosition(
            productPosition,
            event.currentTarget.dataset.direction
          );

          if (
            productPosition > products[products.length - 1] &&
            event.currentTarget.dataset.direction === 'right'
          ) {
            productPosition = products[0];
            openPanelOnCarouselClick(
              $quickShopPanelElement,
              productPosition,
              carouselIsVisibleClass
            );

            return;
          }

          if (productPosition < products[0] && event.currentTarget.dataset.direction === 'left') {
            productPosition = products[products.length - 1];
            openPanelOnCarouselClick(
              $quickShopPanelElement,
              productPosition,
              carouselIsVisibleClass
            );

            return;
          }

          openPanelOnCarouselClick($quickShopPanelElement, productPosition, carouselIsVisibleClass);
        }

        function determineCorrectProductPosition(productPosition, direction) {
          switch (direction) {
            case 'right':
              productPosition += 1;
              break;
            case 'left':
              productPosition -= 1;
              break;
          }

          return productPosition;
        }

        function processCarouselPanelCloseEvent($quickShopPanelElement, $quickShopPanelCloseElement) {
          $quickShopPanelCloseElement.on('click', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            $quickShopPanelElement.addClass('panel-is-closing');
            fireAnalytic('carousel panel closed', 'click');
            // this is setting the opacity to 0 so the animations don't clash given we have three possible states of carousel.
            setTimeout(function () {
              $quickShopPanelElement.css('opacity', 0);
              toggleCarouselIsVisibleClass($quickShopPanelElement, false);
              removePanelIsVisibleFromRightLeftClasses($quickShopPanelElement);
              $quickShopPanelElement.removeClass('panel-is-closing');
              setTimeout(() => {
                $quickShopPanelElement.css('opacity', 1);
              }, 1000);
            }, 500);
          });
        }

        function removePanelIsVisibleFromRightLeftClasses($quickShopPanelElement) {
          $quickShopPanelElement.removeClass('panel-is-visible-from-right');
          $quickShopPanelElement.removeClass('panel-is-visible-from-left');
        }

        function toggleCarouselIsVisibleClass($quickShopPanelElement, adding) {
          var $productImageContainer = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-product-image');
          var $productDataContainer = $quickShopPanelElement.find('.js-boutique-skin-rhythm__products-quick-shop-panel-product-content');

          adding ? $quickShopPanelElement.addClass('carousel-is-visible') : $quickShopPanelElement.removeClass('carousel-is-visible');
          adding ? $productImageContainer.addClass('carousel-is-visible') : $productImageContainer.removeClass('carousel-is-visible');
          adding ? $productDataContainer.addClass('carousel-is-visible') : $productDataContainer.removeClass('carousel-is-visible');
        }
      }

      addEventsToHeroProducts();
    }
  };
})(jQuery);
